import { FamilyApplicationQueries } from '@/queries/family_applications/queries.ts'
import { useQuery } from '@tanstack/react-query'
import { useParams } from 'react-router-dom'

import { RootState } from '@/storage/store.ts'
import { useSelector } from 'react-redux'
import HistoryView from './HistoryView.tsx'
import { historyType } from '@/app/common/constants'

export default function ApplicantHistoryWrapper() {
  const { applicantId } = useParams<{ applicantId?: string }>()
  const { selectedProgramYear } = useSelector((s: RootState) => s.programs)
  const ApplicantData = useQuery(
    FamilyApplicationQueries.getFamilyApplicationById(
      applicantId!,
      selectedProgramYear!.id,
      {
        staleTime: 0,
        refetchOnMount: true,
      }
    )
  )

  if (ApplicantData.status === 'error') {
    return <div>{ApplicantData.error?.message ?? ''}</div>
  }

  if (ApplicantData.status === 'pending') return <div>Loading</div>

  if (ApplicantData.data?.user_id)
    return (
      <HistoryView
        user_id={ApplicantData.data.user_id}
        user_type_id={historyType.applicant}
      />
    )
  else {
    return <></>
  }
}
